import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ISSUES_CONTAINER: `${cleanedFilename(__filename)}-issues-container`,
  SETTINGS_MENU: `${cleanedFilename(__filename)}-settings-menu`,
};
